<template>
<b-container class="global-settings-container" v-if="globalSettings != null && loaded">
<b-form @submit="false" >
	<h1 class="page-title">Global Settings</h1>
	<b-row>
		<b-col>
			<h2>Default Lane Closure Request Contacts</h2>
			<p>Users assigned to these settings will be automatically added to lane closure requests.
			Removing a user will NOT remove them from existing requests.</p>
		</b-col>
	</b-row>
	<b-row>
		<b-col>
			<b-button variant="outline-primary" class="mr-1" type="button" @click="onExpandAll">Expand All</b-button>
			<b-button variant="outline-primary" type="button" @click="onCollapseAll">Collapse All</b-button><br /><br />
		</b-col>
	</b-row>

	<b-row>
		<b-col lg="6">
			<global-setting-contact ref="defaultApprover" label="Approver" meta-key="default_approver" description="This user will automatically set as the Approver in new lane closure requests.  Only one user can be the default approver." v-model="globalSettings.defaultApprover" v-on:update:add="onAddDefaultApprover" v-on:update:remove="onRemoveDefaultApprover"/>
		</b-col>
		<b-col  lg="6">
			<global-setting-contact ref="cancelledClosureContact" label="Cancelled Closure Contact" meta-key="cancelled_closure_contact" description="Users selected here will be automatically messaged when a submitted lane closure request is cancelled." v-model="globalSettings.cancelledClosureContact" v-on:update:add="onAddCancelledClosureContact" v-on:update:remove="onRemoveCancelledClosureContact"/>
		</b-col>

		<b-col  lg="6">
			<global-setting-contact ref="defaultContact" label="Default Contacts" meta-key="default_contact" description="Users selected here will be automatically attached to new and updated lane closure requests." v-model="globalSettings.defaultContact" v-on:update:add="onAddDefaultContact" v-on:update:remove="onRemoveDefaultContact"/>
		</b-col>
			<b-col lg="6">
				<global-setting-contact ref="defaultEmergencyContact" label="Emergency Contact" meta-key="default_emergency_contact" description="Users will be automatically added to EMERGENCY requests." v-model="globalSettings.defaultEmergencyContact" v-on:update:add="onAddDefaultEmergencyContact" v-on:update:remove="onRemoveDefaultEmergencyContact"/>
			</b-col>

			<b-col  lg="6">
				<global-setting-contact ref="failedReopeningClosureContact" label="Failed Reopening Closure Contact" meta-key="failed_reopening_closure_contact" description="Users selected here will be automatically messaged when a lane closure request has not been reported re-opened after the third time." v-model="globalSettings.failedReopeningClosureContact" v-on:update:add="onAddFailedReopeningClosureContact" v-on:update:remove="onRemoveFailedReopeningClosureContact"/>
			</b-col>

			<b-col  lg="6">
				<global-setting-contact ref="fullClosureContact" label="Full Closure / Directional Closure Contact" meta-key="full_closure_contact" description="Users selected here will be added when a request has full or directional lane closures." v-model="globalSettings.fullClosureContact" v-on:update:add="onAddFullClosureContact" v-on:update:remove="onRemoveFullClosureContact"/>
			</b-col>


			<b-col lg="6">
				<global-setting-contact ref="defaultParkingContact" label="Paid Parking Contact" meta-key="default_parking_contact" description="Users will be automatically added to requests when paid parking needs to be removed." v-model="globalSettings.defaultParkingContact" v-on:update:add="onAddDefaultParkingContact" v-on:update:remove="onRemoveDefaultParkingContact"/>
			</b-col>

			<b-col lg="6">
				<global-setting-contact ref="permitContact" label="Permit Contact" meta-key="permit_contact" description="Users will be automatically added to requests when a permit is required." v-model="globalSettings.permitContact" v-on:update:add="onAddPermitContact" v-on:update:remove="onRemovePermitContact"/>
			</b-col>


		<b-col  lg="6">
			<global-setting-contact ref="systemAccount" label="System Account" meta-key="system_account" description="This account sends emails and performs automatic maintenance functions." v-model="globalSettings.systemAccount" v-on:update:add="onAddSystemAccount" v-on:update:remove="onRemoveSystemAccount"/>
		</b-col>
			<b-col lg="6">
				<global-setting-contact ref="defaultTrafficServicesContact"  label="Traffic Services Contact" meta-key="default_traffic_services_contact" description="Users will be automatically added to requests." v-model="globalSettings.defaultTrafficServicesContact" v-on:update:add="onAddDefaultTrafficServicesContact" v-on:update:remove="onRemoveDefaultTrafficServicesContact"/>
			</b-col>

			<b-col lg="6">
				<global-setting-contact ref="defaultTrafficSignalsContact" label="Traffic Signals Contact" meta-key="default_traffic_signals_contact" description="User will be automatically added to requests when traffic signals are altered." v-model="globalSettings.defaultTrafficSignalsContact" v-on:update:add="onAddDefaultTrafficSignalsContact" v-on:update:remove="onRemoveDefaultTrafficSignalsContact"/>
			</b-col>

			<b-col lg="6">
				<global-setting-contact ref="defaultTransitContact" label="Transit Contact" meta-key="default_transit_contact" description="Users will be automatically added to requests when transit is affected." v-model="globalSettings.defaultTransitContact" v-on:update:add="onAddDefaultTransitContact" v-on:update:remove="onRemoveDefaultTransitContact"/>
			</b-col>

			<b-col lg="6">
				<global-setting-contact ref="defaultDCZContact" label="Designated Construction Zone (DCZ) Contact" meta-key="default_dcz_contact" description="Users will be automatically added to requests when DCZ is requested." v-model="globalSettings.defaultDCZContact" v-on:update:add="onAddDefaultDCZContact" v-on:update:remove="onRemoveDefaultDCZContact"/>
			</b-col>
		</b-row>
	<b-row>
		<b-col>
			<b-row><b-col>
			<b-button variant="primary" type="button" @click="onSubmit">Save Global Settings <b-spinner small label="Saving..." class="ml-2" v-if="saving"></b-spinner></b-button>
		</b-col></b-row>
		</b-col>
	</b-row>

</b-form>
</b-container>
</template>


<script>
import GlobalSettings from '../../../models/GlobalSettings';
import Vue from 'vue'
import GlobalSettingContact from '../../../components/GlobalSettingContact';
import ErrorHandler from '../../../utility/ErrorHandler';


export default {
	name: 'EditGlobalSettings',
	docTitle: "Global Settings - Lane Closures",

	components: {
	GlobalSettingContact,
	},

	data() {
	return {
		globalSettings: null,
		loaded:false,
		saving:false,
	}
	},
	mounted() {
		this.Load();
	},
	computed: {},

	watch: {},

	methods: {

		Load() {
				this.loaded = false;
				Vue.prototype.$http({
					method: 'get',
					url: `${this.$store.state.apiUrl}/setting?r=${Math.round(Math.random() * Math.pow(10, 6))}`
				}).then(response => {
					this.globalSettings = new GlobalSettings(response.data);
					this.loaded = true;
				}).catch(error => {
					if (!ErrorHandler.HasLoginErrorCode(error)) {
						if (error.response && error.response.data) {
							this.loaded = false;
							this.transactionStatus = 'load-error';
							this.errorDetails = error.response.data;
						}
					} else {
						// ErrorHandler.RedirectToLogin();
					}
				});
		},

		onAddSystemAccount(data) {
			// only one entry allowed
			this.globalSettings.systemAccount = [];
			this.globalSettings.systemAccount.push(data);
		},

		onRemoveSystemAccount(index) {
			this.globalSettings.systemAccount.splice(index, 1);
		},
			onAddDefaultContact(data) {
				this.globalSettings.defaultContact.push(data);
			},

			onRemoveDefaultContact(index) {
				this.globalSettings.defaultContact.splice(index, 1);
			},

			onAddFullClosureContact(data) {
				this.globalSettings.fullClosureContact.push(data);
			},

			onRemoveFullClosureContact(index) {
				this.globalSettings.fullClosureContact.splice(index, 1);
			},

			onAddDefaultTrafficSignalsContact(data) {
				this.globalSettings.defaultTrafficSignalsContact.push(data);
			},

			onRemoveDefaultTrafficSignalsContact(index) {
				this.globalSettings.defaultTrafficSignalsContact.splice(index, 1);
			},


			onAddDefaultTrafficServicesContact(data) {
				this.globalSettings.defaultTrafficServicesContact.push(data);
			},

			onRemoveDefaultTrafficServicesContact(index) {
				this.globalSettings.defaultTrafficServicesContact.splice(index, 1);
			},

			onAddDefaultEmergencyContact(data) {
				this.globalSettings.defaultEmergencyContact.push(data);
			},

			onRemoveDefaultEmergencyContact(index) {
				this.globalSettings.defaultEmergencyContact.splice(index, 1);
			},

			onAddDefaultApprover(data) {
				// only one approver
				this.globalSettings.defaultApprover = [];
				this.globalSettings.defaultApprover.push(data);
			},

			onRemoveDefaultApprover(index) {
				this.globalSettings.defaultApprover.splice(index, 1);
			},

			onAddDefaultParkingContact(data) {
				this.globalSettings.defaultParkingContact.push(data);
			},

			onRemoveDefaultParkingContact(index) {
				this.globalSettings.defaultParkingContact.splice(index, 1);
			},

			onAddPermitContact(data) {
				this.globalSettings.permitContact.push(data);
			},

			onRemovePermitContact(index) {
				this.globalSettings.permitContact.splice(index, 1);
			},



			onAddDefaultTransitContact(data) {
				this.globalSettings.defaultTransitContact.push(data);
			},

			onRemoveDefaultTransitContact(index) {
				this.globalSettings.defaultTransitContact.splice(index, 1);
			},


			onAddCancelledClosureContact(data) {
				this.globalSettings.cancelledClosureContact.push(data);
			},

			onRemoveCancelledClosureContact(index) {
				this.globalSettings.cancelledClosureContact.splice(index, 1);
			},

			onAddFailedReopeningClosureContact(data) {
				this.globalSettings.failedReopeningClosureContact.push(data);
			},

			onRemoveFailedReopeningClosureContact(index) {
				this.globalSettings.failedReopeningClosureContact.splice(index, 1);
			},


			// onAddDefaultOfficer(data) {
			// 	this.globalSettings.defaultOfficer.push(data);
			// },

			// onRemoveDefaultOfficer(index) {
			// 	this.globalSettings.defaultOfficer.splice(index, 1);
			// },

			onAddDefaultDCZContact(data) {
				this.globalSettings.defaultDCZContact.push(data);
			},

			onRemoveDefaultDCZContact(index) {
				this.globalSettings.defaultDCZContact.splice(index, 1);
			},


			onExpandAll() {
				this.$refs.defaultContact.onExpand();
				this.$refs.defaultApprover.onExpand();
				this.$refs.defaultEmergencyContact.onExpand();
				this.$refs.defaultParkingContact.onExpand();
				this.$refs.systemAccount.onExpand();
				this.$refs.defaultTrafficServicesContact.onExpand();
				this.$refs.defaultTrafficSignalsContact.onExpand();
				this.$refs.defaultTransitContact.onExpand();
				this.$refs.cancelledClosureContact.onExpand();
				this.$refs.failedReopeningClosureContact.onExpand();
				// this.$refs.defaultOfficer.onExpand();
				this.$refs.defaultDCZContact.onExpand();
			},
			onCollapseAll() {
				this.$refs.defaultContact.onCollapse();
				this.$refs.defaultApprover.onCollapse();
				this.$refs.defaultEmergencyContact.onCollapse();
				this.$refs.defaultParkingContact.onCollapse();
				this.$refs.systemAccount.onCollapse();
				this.$refs.defaultTrafficServicesContact.onCollapse();
				this.$refs.defaultTrafficSignalsContact.onCollapse();
				this.$refs.defaultTransitContact.onCollapse();
				this.$refs.cancelledClosureContact.onCollapse();
				this.$refs.failedReopeningClosureContact.onCollapse();
				// this.$refs.defaultOfficer.onCollapse();
				this.$refs.defaultDCZContact.onCollapse();
			},

		onSubmit() {
			this.saving = true;
			Vue.prototype.$http({
				method: 'put',
				url: `${this.$store.state.apiUrl}/setting/?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
				data: this.globalSettings.getRawValue()
			}).then(() => {
				this.saveState = 'success';
				this.submissionStatus = 'submission-success';
			}).catch(error => {
				this.saveState = 'fail';
				if (error) {
					if (error.response) {
						if (!ErrorHandler.HasLoginErrorCode(error)) {
							// this.laneClosureRequest.SetErrors(error.response.data);
							this.showErrors(error.response.data.fields);
						} else {
							ErrorHandler.RedirectToLogin();
						}
					}
				}
			}).finally(() => {
				this.isButtonDisabled = false;
				this.saving = false;
			});
		},



	}
}
</script>
<i18n>
{
	"en-CA": {

	}
}

</i18n>